// import { adminDetail } from "./adminDetailsReducer";

import { adminDetail } from "./adminDetailsReducer";

export const admin_details = (query) => async (dispatch) => {
    try {
        dispatch(adminDetail(query));
    } catch (err) {
        const error = {
            code: 0,
            message: typeof err == 'object' ? err.message : err,
        };
        throw error;
    }
};